// @flow

import * as React from 'react';

import classNames from '@ta/common.classnames';

import styles from './SocialActionBar.less';

export type Props = {
  className?: string,
  children: React.Node,
};

const SocialActionBar = ({ className, children }: Props) => (
  <div className={classNames(styles.social_action_bar, className)}>{children}</div>
);

SocialActionBar.defaultProps = {
  className: '',
};

export default SocialActionBar;
